import { api_offer_info_path } from '@routes';

import request from './request';
import { OfferOption } from './subscribe';

export interface OffersInfoRequest {
  offer_codes: string[];
}

export const OFFER_KEY = 'OFFER_KEY';

export const getOfferInfo = async (params: OffersInfoRequest): Promise<OfferOption[]> => {
  const response = await request('get', api_offer_info_path(params));
  return response;
};
